// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"118":"rally","180":"story","628":"sagafuro","667":"spot","697":"news","795":"goods","803":"train","913":"post","963":"event"}[chunkId] || chunkId) + ".css";
};